import store from '../store/index'

var Auth = {}

Auth.isAuthenticated = function () {
  return !store.getters.isTokenExpired
}

export default Auth